import React from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  Typography,
  Box
} from '@mui/material'
import {
  Search as SearchOffIcon,
  TableChart as TableIcon
} from '@mui/icons-material'

interface EmptyStateProps {
  message?: string
  icon?: React.ReactNode
  children?: React.ReactNode
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No se encontraron resultados',
  icon,
  children
}) => {
  const styles = useStyles()

  const defaultIcon = message.toLowerCase().includes('busqueda') || 
                     message.toLowerCase().includes('criterios') ? (
    <SearchOffIcon className={styles.icon} />
  ) : (
    <TableIcon className={styles.icon} />
  )

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        {icon || defaultIcon}
        <Typography variant="h6" className={styles.message}>
          {message}
        </Typography>
        {children && (
          <Box className={styles.children}>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.grey[50]
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '400px'
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2)
  },
  message: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(2),
    fontWeight: 400
  },
  children: {
    marginTop: theme.spacing(1)
  }
}))